import { BadgeText } from './BadgeText.component';

export { BadgeText };
